import { render } from "./InfoBadge.vue?vue&type=template&id=3c2badc6"
import script from "./InfoBadge.vue?vue&type=script&lang=js"
export * from "./InfoBadge.vue?vue&type=script&lang=js"

import exportComponent from "/home/noe/Dev/atc/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__